<template>
  <v-container fluid class="webproject-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Web Project</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">New Project</p>
                        <v-text-field
                          class="mb-4"
                          v-model="new_project.projectcode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Project Code"
                          persistent-hint
                          single-line hint="Enter the project code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_project.projectname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Project Name"
                          persistent-hint
                          single-line hint="Enter the project name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="new_project.projecttype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the project type">
                        </v-select>
                        <div class="d-flex justify-end">

                        </div>
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/webproject/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertWebProject()">
                            Save
                          </v-btn>
                      </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      new_project: {},
      items: ['Web Project', 'Other Web Project'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('WebProject', ['insertWebProjectRequest', 'getWebProjectsRequest']),
    checkError(){
      if(!this.new_project.projectcode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_project.projectname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.new_project.projecttype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    async insertWebProject() {
      if(!this.checkError()) return;
      await this.insertWebProjectRequest(this.new_project);
      router.push('/webproject/list');
    },
  },
  computed: {
    ...mapState('WebProject', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
